<template>
    <div class="search-page">
        <div class="searchBar">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="卡组名称">
                    <el-input v-model="formInline.name" placeholder="卡组名称"></el-input>
                </el-form-item>
                <el-form-item label="卡组类型 ">
                    <el-select v-model="formInline.deck_type" placeholder="卡组类型 ">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="单图片卡组" value="1"></el-option>
                        <el-option label="双图片卡组" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否首页 ">
                    <el-select v-model="formInline.is_home_show" placeholder="请选择 ">
                        <el-option label="全部" :value="false"></el-option>
                        <el-option label="首页卡组" :value="true"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit" style="margin-right:6px;">查询</el-button>
                    <el-button @click="onClear">清除</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="btn-box">
            <el-button type="primary" @click="addGroup">新增卡组</el-button>
        </div>
        <div class="table-box">
            <el-table :data="tableData" size="small" >
                <el-table-column prop="name" label="卡组名称"></el-table-column>
                <el-table-column prop="deck_type" label="卡组类型">
                    <template slot-scope="scope">
                        {{scope.row.deck_type=='1'?'单图片卡组':'双图片卡组'}}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="220">
                    <template slot-scope="scope">
                        <el-button @click="changeGroup(scope)" type="text" size="small">编辑</el-button>
                        <el-button @click="changeCard(scope)" type="text" size="small">编辑卡牌</el-button>
                        <el-button @click="dele(scope)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.page"
                    :page-sizes="[10, 20, 30, 100]"
                    :page-size="pagination.page_size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <editGroup :showCardDetail="showCardDetail" :formData="formData" @closeDetail="closeDetail" />
        <changeCardCom :showCardDetail="showCardDetail1" :selectData="selectData" :nowCardList="nowCardList" @closeDetail="closeDetail1" @openCardList="openCardList" />
        <cardListCom :showCardList="showCardList" :selectGroupType="selectGroupType" :nowCardList="nowCardList" @closeList="closeList" />
    </div>
</template>
<script>

import {groupList,deleteGroup} from '../api/index'
import editGroup from '../components/editGroup'
import changeCardCom from '../components/changeCard'
import cardListCom from '../components/checkCardList'
export default {
    name:'CardListPage',
    components:{editGroup,changeCardCom,cardListCom},
    data() {
        return {
            formInline: {
                name: '',
                deck_type: '',
                is_home_show:false,
            },
            pagination:{
                page: 1,
                page_size: 10,
            },
            total:0,
            tableData: [],
            showCardDetail:false,
            showCardDetail1:false,
            showCardList:false,
            formData:{},
            selectData:{},
            nowCardList:[],
            selectGroupType:''
        }
    },
    created() {
        this.groupList();
    },
    methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pagination.page_size = val;
            this.onSubmit();
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pagination.page = val;
            this.cardList();
        },
        onSubmit() {
            console.log('submit!');
            this.pagination.page = 1;
            this.groupList();
        },
        onClear(){
            this.formInline = {
                name: '',
                deck_type: '',
                is_home_show:false,
            }
        },
        indexMethod(index) {
            return index * 2;
        },
        groupList(){
            groupList({...this.formInline,...this.pagination}).then(res => {
                this.tableData = res.data.data
                this.total = res.data.total
            })
        },
        addGroup(){
            this.showCardDetail = true
            this.formData = {}
        },
        changeGroup(e){
            this.showCardDetail = true
            this.formData = e.row
        },
        closeDetail(e){
            if(e) {
                this.groupList();
            }
            this.showCardDetail = false
        },
        closeDetail1(e){
            if(e) {
                this.groupList();
            }
            this.showCardDetail1 = false
        },
        dele(e) {
            this.$confirm('确认删除？').then(() => {
                deleteGroup({id:e.row.id}).then(res => {
                    if(res.message == 'success' ){
                        this.$message('删除成功');
                        this.groupList();
                    }
                })
            })
        },
        changeCard(e){
            this.selectData = e.row
            this.selectGroupType = e.row.deck_type
            this.showCardDetail1 = true
        },
        openCardList(e){
            console.log(e);
            this.nowCardList = e
            this.showCardList = true
        },
        closeList(e){
            console.log(e);
            if(e&&e.length) {
                this.nowCardList = e
            }
            this.showCardList = false
        }
    },
}
</script>
<style lang="scss">
.search-page {
    width: 100%;
    .searchBar {
        min-height: 60px;
    }
    .btn-box {
        height: 40px;
        margin-bottom: 10px;
    }
    .table-box {
        .el-table {
            height: 100%;
            box-sizing: border-box;
            thead {
                color:#909399;
                th {
                    background: #f6f6f6;
                }
            }
        }
    }
}
    .demo-form-inline {
        margin-top: 20px;
    }
</style>